import { RefreshResponse } from "../entities/CreditSummaryEntity";
import { CreditsRepository } from "../repositories/CreditsRepository";

export class RefreshCustomerCreditsCacheUseCase {
  constructor(private repository: CreditsRepository) {}

  async execute(): Promise<RefreshResponse> {
    return await this.repository.refreshCustomerCreditsCache();
  }
}

